/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ResolveTo = core.serialization.enum_(["clip", "main", "snapshot"]);
